// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as OrderStatus from "../../../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ProgressModal from "../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as HasWaypointForm from "./sub-section-form/HasWaypointForm.bs.js";
import * as OrderStatusForm from "./sub-section-form/OrderStatusForm.bs.js";
import * as Switch$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/switch/Switch.bs.js";
import * as DryRunDistanceForm from "./sub-section-form/DryRunDistanceForm.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as EditOrderDataMachine from "../../../app/repo/EditOrderDataMachine.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as SubmitModalConfirmation from "../sidebars/SubmitModalConfirmation.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SecondaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/SecondaryButton.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as FormDateTimeInputTs$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormDateTimeInputTs.bs.js";
import * as ActualPartnerCollectedCashForm from "./sub-section-form/ActualPartnerCollectedCashForm.bs.js";

function editOrderGaEventForsuccessfulFormSubmission(label) {
  return EventTracker.publishEvent({
              category: "Edit Order GA4",
              action: "New Edit Order submit successful",
              label: label,
              value: undefined,
              nonInteraction: undefined
            });
}

function editOrderGaEventForFailedFormSubmission(label) {
  return EventTracker.publishEvent({
              category: "Edit Order GA4",
              action: "New Edit Order submit Failure",
              label: label,
              value: undefined,
              nonInteraction: undefined
            });
}

function getOrderDetails(orderDetails) {
  return orderDetails._0;
}

function EditOrderForm(Props) {
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var changeDiscardModalState = Props.changeDiscardModalState;
  var order = Props.order;
  var order_fare = Props.order_fare;
  var manualOrderUpdateReason = Props.manualOrderUpdateReason;
  var openSnackbar = Props.openSnackbar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return false;
      });
  var updateCnfModal = match$1[1];
  var match$2 = React.useState(function () {
        return false;
      });
  var updateLoaderState = match$2[1];
  var match$3 = React.useState(function () {
        return /* EditOrderInit */0;
      });
  var setFormState = match$3[1];
  var form_state = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var updateHasWaypoint = match$4[1];
  var has_waypoint = match$4[0];
  React.useEffect((function () {
          if (has_waypoint) {
            
          } else {
            Curry._1(setFormState, (function (param) {
                    return /* EditOrderInit */0;
                  }));
          }
          
        }), [has_waypoint]);
  var order$1 = order._0;
  var orderStatus = order$1.status;
  var crn = order$1.order_crn;
  var order_updated_at = order$1.order_updated_at;
  var disableEditOrderPost12hrsforTR;
  var exit = 0;
  var endedOrder;
  switch (order.TAG | 0) {
    case /* Ended */3 :
        endedOrder = order._3;
        exit = 1;
        break;
    case /* CancelledEnded */8 :
        endedOrder = order._4;
        exit = 1;
        break;
    default:
      disableEditOrderPost12hrsforTR = false;
  }
  if (exit === 1) {
    disableEditOrderPost12hrsforTR = country.TAG === /* TR */3 ? Timestamp$Catalyst.isAfter(Timestamp$Catalyst.now(undefined), Timestamp$Catalyst.getDateTimeAfterElapsedTime(12.0, /* Hours */5, endedOrder.trip_end_time)) : false;
  }
  var submitForm = function (updateOrderStatusFormData, actualPartnerCollectedCashFormData, updateDryRunDistanceFormData, updateWaypointFormData) {
    Curry._1(updateLoaderState, (function (prevState) {
            return !prevState;
          }));
    switch (form_state) {
      case /* EditOrderInit */0 :
          return Curry._1(updateLoaderState, (function (prevState) {
                        return !prevState;
                      }));
      case /* OrderStatusEnabled */1 :
          var payload = OrderStatusForm.OrderStatusFormHelper.getPayload(updateOrderStatusFormData, crn, order_updated_at, orderStatus);
          if (payload !== undefined) {
            return EditOrderDataMachine.updateOrderStatus(payload, (function (_data) {
                          Curry._1(toggleEditOrderSidebar, undefined);
                          Curry._1(changeDiscardModalState, (function (param) {
                                  return false;
                                }));
                          Curry._1(updateLoaderState, (function (prevState) {
                                  return !prevState;
                                }));
                          Curry._1(openSnackbar, {
                                TAG: /* Success */0,
                                _0: "Order Updated Successfully"
                              });
                          return editOrderGaEventForsuccessfulFormSubmission("Order status");
                        }), (function (error) {
                          Curry._1(openSnackbar, {
                                TAG: /* Error */1,
                                _0: ErrorUtils$Catalyst.resolveError(error)
                              });
                          editOrderGaEventForFailedFormSubmission("Order status");
                          return Curry._1(updateLoaderState, (function (prevState) {
                                        return !prevState;
                                      }));
                        }), country);
          } else {
            return ;
          }
      case /* PartnerCollectedCashEnabled */2 :
          var payload$1 = ActualPartnerCollectedCashForm.ActualPartnerCollectedCashHelper.getPayload(actualPartnerCollectedCashFormData, crn, order_updated_at);
          if (payload$1 !== undefined) {
            return EditOrderDataMachine.updateActualPartnerCollectedCash(payload$1, (function (_data) {
                          Curry._1(toggleEditOrderSidebar, undefined);
                          Curry._1(changeDiscardModalState, (function (param) {
                                  return false;
                                }));
                          Curry._1(updateLoaderState, (function (prevState) {
                                  return !prevState;
                                }));
                          Curry._1(openSnackbar, {
                                TAG: /* Success */0,
                                _0: "Order Updated Successfully"
                              });
                          return editOrderGaEventForsuccessfulFormSubmission("Actual partner collected cash");
                        }), (function (error) {
                          Curry._1(openSnackbar, {
                                TAG: /* Error */1,
                                _0: ErrorUtils$Catalyst.resolveError(error)
                              });
                          editOrderGaEventForFailedFormSubmission("Actual partner collected cash");
                          return Curry._1(updateLoaderState, (function (prevState) {
                                        return !prevState;
                                      }));
                        }), country);
          } else {
            return ;
          }
      case /* DryRunDistanceEnabled */3 :
          var payload$2 = DryRunDistanceForm.DryRunDistanceFormHelper.getPayload(updateDryRunDistanceFormData, crn, order_updated_at);
          if (payload$2 !== undefined) {
            return EditOrderDataMachine.updateDryRunDistance(payload$2, (function (_data) {
                          Curry._1(toggleEditOrderSidebar, undefined);
                          Curry._1(changeDiscardModalState, (function (param) {
                                  return false;
                                }));
                          Curry._1(updateLoaderState, (function (prevState) {
                                  return !prevState;
                                }));
                          Curry._1(openSnackbar, {
                                TAG: /* Success */0,
                                _0: "Order Updated Successfully"
                              });
                          return editOrderGaEventForsuccessfulFormSubmission("Dry run distance");
                        }), (function (error) {
                          Curry._1(openSnackbar, {
                                TAG: /* Error */1,
                                _0: ErrorUtils$Catalyst.resolveError(error)
                              });
                          editOrderGaEventForFailedFormSubmission("Dry run distance");
                          return Curry._1(updateLoaderState, (function (prevState) {
                                        return !prevState;
                                      }));
                        }), country);
          } else {
            return ;
          }
      case /* HasWaypointEnabled */4 :
          var payload$3 = HasWaypointForm.HasWaypointFormHelper.getPayload(updateWaypointFormData, crn, order_updated_at);
          if (payload$3 !== undefined) {
            return EditOrderDataMachine.updateHasWaypoints(payload$3, (function (_data) {
                          Curry._1(toggleEditOrderSidebar, undefined);
                          Curry._1(changeDiscardModalState, (function (param) {
                                  return false;
                                }));
                          Curry._1(updateLoaderState, (function (prevState) {
                                  return !prevState;
                                }));
                          Curry._1(openSnackbar, {
                                TAG: /* Success */0,
                                _0: "Order Updated Successfully"
                              });
                          return editOrderGaEventForsuccessfulFormSubmission("Has waypoint");
                        }), (function (error) {
                          Curry._1(openSnackbar, {
                                TAG: /* Error */1,
                                _0: ErrorUtils$Catalyst.resolveError(error)
                              });
                          editOrderGaEventForFailedFormSubmission("Has waypoint");
                          return Curry._1(updateLoaderState, (function (prevState) {
                                        return !prevState;
                                      }));
                        }), country);
          } else {
            return ;
          }
      
    }
  };
  var updateStatusform = OrderStatusForm.OrderStatusForm.useForm(OrderStatusForm.OrderStatusFormHelper.getInitialInput(order, orderStatus), {
        isFormActive: form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state,
        orderStatus: orderStatus,
        manualOrderUpdateReason: manualOrderUpdateReason,
        currentTime: Timestamp$Catalyst.now(undefined),
        order: order._0
      }, (function (output, _form) {
          return submitForm(output, undefined, undefined, undefined);
        }));
  var updatePartnerCollectedCashform = ActualPartnerCollectedCashForm.ActualPartnerCollectedCashForm.useForm(ActualPartnerCollectedCashForm.ActualPartnerCollectedCashHelper.getInitialInput(order_fare), {
        isFormActive: form_state === /* EditOrderInit */0 || /* PartnerCollectedCashEnabled */2 === form_state,
        orderStatus: orderStatus,
        order: order
      }, (function (output, _form) {
          return submitForm(undefined, output, undefined, undefined);
        }));
  var updateDryRunDistanceform = DryRunDistanceForm.DryRunDistanceForm.useForm(DryRunDistanceForm.DryRunDistanceFormHelper.getInitialInput(order), {
        isFormActive: form_state === /* EditOrderInit */0 || /* DryRunDistanceEnabled */3 === form_state,
        orderDetails: order,
        orderStatus: orderStatus
      }, (function (output, _form) {
          return submitForm(undefined, undefined, output, undefined);
        }));
  var updateWaypointform = HasWaypointForm.HasWaypointForm.useForm(HasWaypointForm.HasWaypointFormHelper.getInitialInput(order), {
        isFormActive: form_state === /* EditOrderInit */0 || /* HasWaypointEnabled */4 === form_state,
        orderDetails: order,
        orderStatus: orderStatus
      }, (function (output, _form) {
          return submitForm(undefined, undefined, undefined, output);
        }));
  var value = updateStatusform.input.msisdn;
  var amount = updatePartnerCollectedCashform.input.totalAmountPaid;
  var value$1 = updatePartnerCollectedCashform.input.actualPartnerCollectedCash;
  var value$2 = updateDryRunDistanceform.input.dryRunDistance;
  var match$5 = HasWaypointForm.getCurrentWaypointStatus(order);
  var match$6 = HasWaypointForm.getAdditionalWaypointEligible(order);
  var tmp;
  var exit$1 = 0;
  switch (country.TAG | 0) {
    case /* UAE */0 :
        if (match$5) {
          exit$1 = 1;
        } else {
          tmp = null;
        }
        break;
    case /* India */1 :
        if (match$5 && match$6 !== undefined && match$6) {
          exit$1 = 1;
        } else {
          tmp = null;
        }
        break;
    default:
      tmp = null;
  }
  if (exit$1 === 1) {
    tmp = React.createElement(Row$Catalyst.make, {
          children: React.createElement("div", undefined, React.createElement("label", undefined, "Additional Waypoint Requested"), React.createElement(Switch$Catalyst.make, {
                    checked: updateWaypointform.input.hasAdditionalWayPoint,
                    on_change: (function (_event) {
                        Curry._1(setFormState, (function (param) {
                                return /* HasWaypointEnabled */4;
                              }));
                        return Curry._2(updateWaypointform.updateHasAdditionalWayPoint, (function (input, param) {
                                      return {
                                              hasWayPoint: input.hasWayPoint,
                                              hasAdditionalWayPoint: !has_waypoint
                                            };
                                    }), (Curry._1(updateHasWaypoint, (function (prevState) {
                                            return !prevState;
                                          })), has_waypoint));
                      }),
                    disabled: !HasWaypointForm.isUpdateWaypointActive(orderStatus) || !(form_state === /* EditOrderInit */0 || /* HasWaypointEnabled */4 === form_state) || !HasWaypointForm.getAdditionalWaypointStatus(order),
                    switch_color: /* Primary */1
                  }))
        });
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "edit-order-form"
                }, React.createElement("form", {
                      className: "update-status-form"
                    }, React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, React.createElement("label", undefined, "MSISDN"), React.createElement(FormTextInput$Catalyst.make, {
                                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                          Curry._1(setFormState, (function (param) {
                                                  return /* OrderStatusEnabled */1;
                                                }));
                                          return Curry._2(updateStatusform.updateMsisdn, (function (input, value) {
                                                        return {
                                                                msisdn: value,
                                                                orderStatus: input.orderStatus,
                                                                actualTripAcceptTime: input.actualTripAcceptTime,
                                                                actualTripStartTime: input.actualTripStartTime,
                                                                tripEndTime: input.tripEndTime,
                                                                tripCompletedTime: input.tripCompletedTime,
                                                                manualUpdateReason: input.manualUpdateReason
                                                              };
                                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                        }), !OrderStatusForm.isMsisdnEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state), undefined, "Enter Driver MSISDN", undefined, undefined, undefined, updateStatusform.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  textinput_props: {
                                    value: value !== undefined ? value : ""
                                  }
                                })), React.createElement("div", undefined, React.createElement("label", undefined, "Order Status"), React.createElement(FormSelectInput$Catalyst.make, {
                                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                          Curry._1(setFormState, (function (param) {
                                                  return /* OrderStatusEnabled */1;
                                                }));
                                          return Curry._2(updateStatusform.updateOrderStatus, (function (input, value) {
                                                        return {
                                                                msisdn: input.msisdn,
                                                                orderStatus: value,
                                                                actualTripAcceptTime: input.actualTripAcceptTime,
                                                                actualTripStartTime: input.actualTripStartTime,
                                                                tripEndTime: input.tripEndTime,
                                                                tripCompletedTime: input.tripCompletedTime,
                                                                manualUpdateReason: input.manualUpdateReason
                                                              };
                                                      }), OrderStatusForm.getOrderStatusDropdownItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), orderStatus));
                                        }), !OrderStatusForm.isOrderStatusEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state), undefined, undefined, undefined, undefined, undefined, updateStatusform.orderStatusResult, undefined, "edit-order-select-style", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  select_props: {
                                    value: updateStatusform.input.orderStatus,
                                    items: OrderStatusForm.getUpdateOrderStatusSelectData(orderStatus),
                                    isNoneRequired: false
                                  }
                                }))), React.createElement("div", {
                          className: "date-time-fields"
                        }, React.createElement(Row$Catalyst.make, {
                              children: React.createElement("div", undefined, React.createElement("label", undefined, "Trip Actual Accept Date Time"), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                        input_props: FormInput$Catalyst.make_props("", (function (param) {
                                                
                                              }), undefined, undefined, undefined, undefined, undefined, undefined, updateStatusform.actualTripAcceptTimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                        date_props: {
                                          value: updateStatusform.input.actualTripAcceptTime,
                                          minDate: undefined,
                                          maxDate: undefined,
                                          onChange: (function (date) {
                                              Curry._1(setFormState, (function (param) {
                                                      return /* OrderStatusEnabled */1;
                                                    }));
                                              return Curry._2(updateStatusform.updateActualTripAcceptTime, (function (input, value) {
                                                            return {
                                                                    msisdn: input.msisdn,
                                                                    orderStatus: input.orderStatus,
                                                                    actualTripAcceptTime: value,
                                                                    actualTripStartTime: input.actualTripStartTime,
                                                                    tripEndTime: input.tripEndTime,
                                                                    tripCompletedTime: input.tripCompletedTime,
                                                                    manualUpdateReason: input.manualUpdateReason
                                                                  };
                                                          }), Caml_option.some(date));
                                            }),
                                          format: "DD/MM/YYYY h:mm A",
                                          isDisabled: !OrderStatusForm.isActualTripAcceptTimeEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state),
                                          onClear: (function (param) {
                                              return Curry._2(updateStatusform.updateActualTripAcceptTime, (function (input, _value) {
                                                            return {
                                                                    msisdn: input.msisdn,
                                                                    orderStatus: input.orderStatus,
                                                                    actualTripAcceptTime: undefined,
                                                                    actualTripStartTime: input.actualTripStartTime,
                                                                    tripEndTime: input.tripEndTime,
                                                                    tripCompletedTime: input.tripCompletedTime,
                                                                    manualUpdateReason: input.manualUpdateReason
                                                                  };
                                                          }), undefined);
                                            })
                                        }
                                      }))
                            }), React.createElement(Row$Catalyst.make, {
                              children: React.createElement("div", undefined, React.createElement("label", undefined, "Trip Actual Start Date Time"), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                        input_props: FormInput$Catalyst.make_props("", (function (param) {
                                                
                                              }), undefined, undefined, undefined, undefined, undefined, undefined, updateStatusform.actualTripStartTimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                        date_props: {
                                          value: updateStatusform.input.actualTripStartTime,
                                          minDate: undefined,
                                          maxDate: undefined,
                                          onChange: (function (date) {
                                              Curry._1(setFormState, (function (param) {
                                                      return /* OrderStatusEnabled */1;
                                                    }));
                                              return Curry._2(updateStatusform.updateActualTripStartTime, (function (input, value) {
                                                            return {
                                                                    msisdn: input.msisdn,
                                                                    orderStatus: input.orderStatus,
                                                                    actualTripAcceptTime: input.actualTripAcceptTime,
                                                                    actualTripStartTime: value,
                                                                    tripEndTime: input.tripEndTime,
                                                                    tripCompletedTime: input.tripCompletedTime,
                                                                    manualUpdateReason: input.manualUpdateReason
                                                                  };
                                                          }), Caml_option.some(date));
                                            }),
                                          format: "DD/MM/YYYY h:mm A",
                                          isDisabled: !OrderStatusForm.isActualTripStartTimeEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state),
                                          onClear: (function (param) {
                                              return Curry._2(updateStatusform.updateActualTripStartTime, (function (input, _value) {
                                                            return {
                                                                    msisdn: input.msisdn,
                                                                    orderStatus: input.orderStatus,
                                                                    actualTripAcceptTime: input.actualTripAcceptTime,
                                                                    actualTripStartTime: undefined,
                                                                    tripEndTime: input.tripEndTime,
                                                                    tripCompletedTime: input.tripCompletedTime,
                                                                    manualUpdateReason: input.manualUpdateReason
                                                                  };
                                                          }), undefined);
                                            })
                                        }
                                      }))
                            }), React.createElement(Row$Catalyst.make, {
                              children: React.createElement("div", undefined, React.createElement("label", undefined, "Trip End Date Time"), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                        input_props: FormInput$Catalyst.make_props("", (function (param) {
                                                
                                              }), undefined, undefined, undefined, undefined, undefined, undefined, updateStatusform.tripEndTimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                        date_props: {
                                          value: updateStatusform.input.tripEndTime,
                                          minDate: undefined,
                                          maxDate: undefined,
                                          onChange: (function (date) {
                                              Curry._1(setFormState, (function (param) {
                                                      return /* OrderStatusEnabled */1;
                                                    }));
                                              return Curry._2(updateStatusform.updateTripEndTime, (function (input, value) {
                                                            return {
                                                                    msisdn: input.msisdn,
                                                                    orderStatus: input.orderStatus,
                                                                    actualTripAcceptTime: input.actualTripAcceptTime,
                                                                    actualTripStartTime: input.actualTripStartTime,
                                                                    tripEndTime: value,
                                                                    tripCompletedTime: input.tripCompletedTime,
                                                                    manualUpdateReason: input.manualUpdateReason
                                                                  };
                                                          }), Caml_option.some(date));
                                            }),
                                          format: "DD/MM/YYYY h:mm A",
                                          isDisabled: !OrderStatusForm.isEndTimeEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state),
                                          onClear: (function (param) {
                                              return Curry._2(updateStatusform.updateTripEndTime, (function (input, _value) {
                                                            return {
                                                                    msisdn: input.msisdn,
                                                                    orderStatus: input.orderStatus,
                                                                    actualTripAcceptTime: input.actualTripAcceptTime,
                                                                    actualTripStartTime: input.actualTripStartTime,
                                                                    tripEndTime: undefined,
                                                                    tripCompletedTime: input.tripCompletedTime,
                                                                    manualUpdateReason: input.manualUpdateReason
                                                                  };
                                                          }), undefined);
                                            })
                                        }
                                      }))
                            }), React.createElement(Row$Catalyst.make, {
                              children: OrderStatusForm.isEndTimeEnabled(orderStatus) ? null : React.createElement("div", undefined, React.createElement("label", undefined, "Trip Complete Date Time"), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                                  
                                                }), undefined, undefined, undefined, undefined, undefined, undefined, updateStatusform.tripCompletedTimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                          date_props: {
                                            value: updateStatusform.input.tripCompletedTime,
                                            minDate: undefined,
                                            maxDate: undefined,
                                            onChange: (function (date) {
                                                Curry._1(setFormState, (function (param) {
                                                        return /* OrderStatusEnabled */1;
                                                      }));
                                                return Curry._2(updateStatusform.updateTripCompletedTime, (function (input, value) {
                                                              return {
                                                                      msisdn: input.msisdn,
                                                                      orderStatus: input.orderStatus,
                                                                      actualTripAcceptTime: input.actualTripAcceptTime,
                                                                      actualTripStartTime: input.actualTripStartTime,
                                                                      tripEndTime: input.tripEndTime,
                                                                      tripCompletedTime: value,
                                                                      manualUpdateReason: input.manualUpdateReason
                                                                    };
                                                            }), Caml_option.some(date));
                                              }),
                                            format: "DD/MM/YYYY h:mm A",
                                            isDisabled: !OrderStatusForm.isCompletedTimeEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state),
                                            onClear: (function (param) {
                                                return Curry._2(updateStatusform.updateTripCompletedTime, (function (input, _value) {
                                                              return {
                                                                      msisdn: input.msisdn,
                                                                      orderStatus: input.orderStatus,
                                                                      actualTripAcceptTime: input.actualTripAcceptTime,
                                                                      actualTripStartTime: input.actualTripStartTime,
                                                                      tripEndTime: input.tripEndTime,
                                                                      tripCompletedTime: undefined,
                                                                      manualUpdateReason: input.manualUpdateReason
                                                                    };
                                                            }), undefined);
                                              })
                                          }
                                        }))
                            })), React.createElement(Row$Catalyst.make, {
                          children: OrderStatus.toString(orderStatus) !== Belt_Option.getWithDefault(updateStatusform.input.orderStatus, SelectComponent$Catalyst.defaultSelectItem).value ? React.createElement("div", undefined, React.createElement("label", undefined, "Reason"), React.createElement(FormSelectInput$Catalyst.make, {
                                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                              Curry._1(setFormState, (function (param) {
                                                      return /* OrderStatusEnabled */1;
                                                    }));
                                              return Curry._2(updateStatusform.updateManualUpdateReason, (function (input, value) {
                                                            return {
                                                                    msisdn: input.msisdn,
                                                                    orderStatus: input.orderStatus,
                                                                    actualTripAcceptTime: input.actualTripAcceptTime,
                                                                    actualTripStartTime: input.actualTripStartTime,
                                                                    tripEndTime: input.tripEndTime,
                                                                    tripCompletedTime: input.tripCompletedTime,
                                                                    manualUpdateReason: value
                                                                  };
                                                          }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), OrderStatusForm.makeUpdateOrderStatusSelectComponentList(manualOrderUpdateReason.reasons)));
                                            }), !OrderStatusForm.isManualUpdateReasonEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* OrderStatusEnabled */1 === form_state), undefined, undefined, undefined, undefined, undefined, updateStatusform.manualUpdateReasonResult, undefined, "manual-update-reason-field edit-order-select-style", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                      select_props: {
                                        value: updateStatusform.input.manualUpdateReason,
                                        items: OrderStatusForm.makeUpdateOrderStatusSelectComponentList(manualOrderUpdateReason.reasons),
                                        isNoneRequired: false
                                      }
                                    })) : null
                        })), React.createElement("form", {
                      className: "update-partner-collected-cash-form"
                    }, React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, React.createElement(LabelUnit$Catalyst.make, {
                                  label: "Total Amount Paid",
                                  unit: CountryConfig.getSymbol(country),
                                  className: "edit-order-label-unit"
                                }), React.createElement(FormTextInput$Catalyst.make, {
                                  input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                          
                                        }), true, undefined, undefined, undefined, undefined, undefined, updatePartnerCollectedCashform.totalAmountPaidResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  textinput_props: {
                                    value: amount !== undefined ? Currency.toString(Caml_option.valFromOption(amount)) : ""
                                  }
                                })), React.createElement("div", undefined, React.createElement(LabelUnit$Catalyst.make, {
                                  label: "Actual Driver Collected Cash",
                                  unit: CountryConfig.getSymbol(country),
                                  className: "edit-order-label-unit"
                                }), React.createElement(FormTextInput$Catalyst.make, {
                                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                          Curry._1(setFormState, (function (param) {
                                                  return /* PartnerCollectedCashEnabled */2;
                                                }));
                                          return Curry._2(updatePartnerCollectedCashform.updateActualPartnerCollectedCash, (function (input, value) {
                                                        return {
                                                                totalAmountPaid: input.totalAmountPaid,
                                                                actualPartnerCollectedCash: value
                                                              };
                                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                        }), !ActualPartnerCollectedCashForm.isActualPartnerCollectedCashEnabled(orderStatus, order) || !(form_state === /* EditOrderInit */0 || /* PartnerCollectedCashEnabled */2 === form_state), undefined, "", undefined, undefined, undefined, updatePartnerCollectedCashform.actualPartnerCollectedCashResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  textinput_props: {
                                    value: value$1 !== undefined ? value$1 : ""
                                  }
                                })))), React.createElement("form", {
                      className: "update-dryrun-distance-form"
                    }, React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Dry Run Kilometers"), React.createElement(FormTextInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            Curry._1(setFormState, (function (param) {
                                                    return /* DryRunDistanceEnabled */3;
                                                  }));
                                            return Curry._2(updateDryRunDistanceform.updateDryRunDistance, (function (_input, value) {
                                                          return {
                                                                  dryRunDistance: value
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), !DryRunDistanceForm.isUpdateDryRunEnabled(orderStatus) || !(form_state === /* EditOrderInit */0 || /* DryRunDistanceEnabled */3 === form_state), undefined, "", undefined, undefined, undefined, updateDryRunDistanceform.dryRunDistanceResult, undefined, "update-dryrun-distance-filed", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    textinput_props: {
                                      value: value$2 !== undefined ? value$2 : ""
                                    }
                                  }))
                        })), React.createElement("form", {
                      className: "update-waypoint-status-form"
                    }, React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Trip has Waypoint"), React.createElement(Switch$Catalyst.make, {
                                    checked: updateWaypointform.input.hasWayPoint,
                                    on_change: (function (_event) {
                                        Curry._1(setFormState, (function (param) {
                                                return /* HasWaypointEnabled */4;
                                              }));
                                        return Curry._2(updateWaypointform.updateHasWayPoint, (function (input, param) {
                                                      return {
                                                              hasWayPoint: !has_waypoint,
                                                              hasAdditionalWayPoint: input.hasAdditionalWayPoint
                                                            };
                                                    }), (Curry._1(updateHasWaypoint, (function (prevState) {
                                                            return !prevState;
                                                          })), has_waypoint));
                                      }),
                                    disabled: !HasWaypointForm.isUpdateWaypointActive(orderStatus) || !(form_state === /* EditOrderInit */0 || /* HasWaypointEnabled */4 === form_state) || HasWaypointForm.getCurrentWaypointStatus(order),
                                    switch_color: /* Primary */1
                                  }))
                        }), tmp)), React.createElement("div", {
                  className: "footer-container"
                }, React.createElement("div", {
                      className: "c-edit-order-footer"
                    }, React.createElement(SecondaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps(form_state !== 0 ? ({
                                    TAG: /* Text */0,
                                    _0: "Reset"
                                  }) : ({
                                    TAG: /* Text */0,
                                    _0: "Close"
                                  }), false, (function (_event) {
                                  if (form_state !== 0) {
                                    Curry._1(updateHasWaypoint, (function (param) {
                                            return false;
                                          }));
                                    Curry._1(updateStatusform.reset, undefined);
                                    Curry._1(updatePartnerCollectedCashform.reset, undefined);
                                    Curry._1(updateDryRunDistanceform.reset, undefined);
                                    Curry._1(updateWaypointform.reset, undefined);
                                    return Curry._1(setFormState, (function (param) {
                                                  return /* EditOrderInit */0;
                                                }));
                                  } else {
                                    return Curry._1(toggleEditOrderSidebar, undefined);
                                  }
                                }), undefined, undefined, undefined, undefined, form_state !== 0 ? "reset-button-enabled" : "close-button-enabled", undefined, undefined)
                        }), React.createElement(PrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Text */0,
                                _0: "Submit"
                              }, form_state === 0, (function (_event) {
                                  if (disableEditOrderPost12hrsforTR) {
                                    return Curry._1(openSnackbar, {
                                                TAG: /* Error */1,
                                                _0: "Editing order details is not allowed 12 hours after the trip has ended"
                                              });
                                  } else {
                                    return Curry._1(updateCnfModal, (function (prevState) {
                                                  return !prevState;
                                                }));
                                  }
                                }), undefined, undefined, undefined, undefined, form_state !== 0 ? "submit-button-enabled" : "button-disabled", undefined, undefined)
                        }), React.createElement(ProgressModal.make, {
                          isOpen: match$2[0]
                        }), React.createElement(SubmitModalConfirmation.make, {
                          isOpen: match$1[0],
                          onCancel: (function (param) {
                              return Curry._1(updateCnfModal, (function (prevState) {
                                            return !prevState;
                                          }));
                            }),
                          onSubmit: (function (param) {
                              Curry._1(updateCnfModal, (function (prevState) {
                                      return !prevState;
                                    }));
                              switch (form_state) {
                                case /* EditOrderInit */0 :
                                case /* OrderStatusEnabled */1 :
                                    return Curry._1(updateStatusform.submit, undefined);
                                case /* PartnerCollectedCashEnabled */2 :
                                    return Curry._1(updatePartnerCollectedCashform.submit, undefined);
                                case /* DryRunDistanceEnabled */3 :
                                    return Curry._1(updateDryRunDistanceform.submit, undefined);
                                case /* HasWaypointEnabled */4 :
                                    return Curry._1(updateWaypointform.submit, undefined);
                                
                              }
                            })
                        }))));
}

var make = EditOrderForm;

export {
  editOrderGaEventForsuccessfulFormSubmission ,
  editOrderGaEventForFailedFormSubmission ,
  getOrderDetails ,
  make ,
  
}
/* react Not a pure module */
